// 简单的Axios修复，解决toUpperCase错误
import axios from 'axios'

// 修复axios库的toUpperCase错误的最简单方式：
// 1. 为axios.defaults设置默认method
// 2. 重写axios.request方法，确保所有请求都有method

// 设置全局默认method
axios.defaults.method = 'get'

// 保存原始的request方法
const originalRequest = axios.request

// 重写request方法
axios.request = function (config) {
  // 确保config是对象
  if (typeof config !== 'object' || config === null) {
    config = {}
  }

  // 确保method存在且是字符串，默认GET
  if (typeof config.method !== 'string') {
    config.method = 'get'
  }

  // 确保url是字符串，否则使用空字符串
  if (typeof config.url !== 'string') {
    config.url = ''
  }

  // 调用原始的request方法，使用call(this)确保上下文正确
  return originalRequest.call(this, config)
}

// 同时修复axios.create方法
const originalCreate = axios.create

axios.create = function (config) {
  const instance = originalCreate(config)

  // 确保新实例有默认method
  instance.defaults.method = 'get'

  // 保存原始的instance.request方法
  const originalInstanceRequest = instance.request

  // 重写instance.request方法
  instance.request = function (config) {
    // 确保config是对象
    if (typeof config !== 'object' || config === null) {
      config = {}
    }

    // 确保method存在且是字符串，默认GET
    if (typeof config.method !== 'string') {
      config.method = 'get'
    }

    // 确保url是字符串，否则使用空字符串
    if (typeof config.url !== 'string') {
      config.url = ''
    }

    // 调用原始的instance.request方法，使用call(this)确保instance上下文正确
    return originalInstanceRequest.call(this, config)
  }

  return instance
}

// 导出axios
export default axios
